import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;

// here from new api
// export const Send_Otp_With_Registration = `${BASE_API_URL}/RamNamBook/SendOtp_WithRegistration`;
// export const VerifyOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/VerifyOtp_RamNamBook`;
export const Get_Countries = `${BASE_API_URL}/Country/Country_GetList_Active`;
export const ResendOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/ResendOtp_RamNamBook2`;
// export const Send_Login_Otp = `${BASE_API_URL}/RamNamBook/SendLogin_Otp`;
export const Send_Login_Otp = `${BASE_API_URL}/RamNamBook/SendLogin_Otp2`;
export const Verify_Login_Otp = `${BASE_API_URL}/RamNamBook/VerifyLogin_Otp`;
// -------------------------------------------
export const Get_Member_Total_Summary = `${BASE_API_URL}/Member/GetMemberTotalSummary`;
export const Get_DigitalRamName_History = `${BASE_API_URL}/DigitalRAMNameTransaction/GetDigitalRamNameHistory`;
export const Get_Digital_RamName_Count = `${BASE_API_URL}/DigitalRAMNameTransaction/GetDigitalRamNameCount`;
export const Submit_Digital_Ram_Name = `${BASE_API_URL}/DigitalRAMNameTransaction/SubmitDigitalRamName_New`;
export const GET_ACTIVE_MEMBER_TYPE = `${BASE_API_URL}/MemberType/MemberType_GetActiveList`; //Get Member Type Page
export const Member_LogIn_New = `${BASE_API_URL}/RamNamBook/MemberLogIn_New`; //Get Member Type Page
export const Member_Change_Password = `${BASE_API_URL}/RamNamBook/ChangePwdByMember`; //Get Member Type Page
export const SendForgot_PWD_MobileNo_OTP = `${BASE_API_URL}/RamNamBook/SendForgot_PWD_MobileNo_OTP`; //Get Member Type Page
export const ForgotPwd_VerifyOtp = `${BASE_API_URL}/RamNamBook/ForgotPwd_VerifyOtp`; //Get Member Type Page
export const ResendForgotPwdOtp = `${BASE_API_URL}/RamNamBook/ResendOtp_ForgotPwd`; //Get Member Type Page
export const Change_Password = `${BASE_API_URL}/Member/Member_ChangePassword`; //Get Member Type Page
export const RamNamBookMember_Position_GetByMember = `${BASE_API_URL}/Member/RamNamBookMember_Position_GetByMemberID`; //Get Member Type Page
// ----------------- latest login Api------------,
export const Get_LastNDays_DigitalRamName_Count = `${BASE_API_URL}/DigitalRAMNameTransaction/GetLastNDaysDigitalRamNameCount`;

export function ResendForgotPwdOtpApi(countryID, mobileNumber, countryCode) {
  return axios.post(ResendForgotPwdOtp, {
    countryID,
    mobileNumber,
    countryCode,
  });
}

export function sendForgotPWDMobileNo_OTPApi(
  countryID,
  mobileNumber,
  countryCode,
) {
  return axios.post(SendForgot_PWD_MobileNo_OTP, {
    countryID,
    mobileNumber,
    countryCode,
  });
}

export function RamNamBookMember_Position_GetByMemberApi(
  ramNamBookMemberID
) {
  return axios.post(RamNamBookMember_Position_GetByMember, {
    ramNamBookMemberID
  });
}
export function verifyForgotPWD_OTPApi(
  ramNamBookMemberID,
  otp,
  // countryCode,
) {
  return axios.post(ForgotPwd_VerifyOtp, {
    ramNamBookMemberID,
    otp,
    // countryCode,
  });
}
// export function sendForgotPWDMobileNo_OTPApi(countryID, mobileNumber) {
//   return axios.post(SendForgot_PWD_MobileNo_OTP, {
//     countryID,
//     mobileNumber,
//   });
// }

// -----------------Reset Password ------------
export function MemberPasswordReset(memberID, newPwd) {
  return axios.post(Member_Change_Password, { memberID, newPwd });
}

export function MemberChangePassword(customerID, oldPwd, newPwd) {
  return axios.post(Change_Password, { customerID, oldPwd, newPwd });
}

export function memberLogIn_NewApi(
  countryID,
  mobileNumber,
  memberTypeID,
  password,
) {
  return axios.post(Member_LogIn_New, {
    countryID,
    mobileNumber,
    memberTypeID,
    password,
  });
}

export function getDigitalRamNameHistoryApi(memberId) {
  return axios.get(`${Get_DigitalRamName_History}?memberId=${memberId}`);
}
export function getLastNDays_DigitalRamNameCountApi(memberId) {
  return axios.get(`${Get_LastNDays_DigitalRamName_Count}?memberId=${memberId}&days=5`);
}

export function getActiveMemberTypeList() {
  return axios.get(GET_ACTIVE_MEMBER_TYPE);
}
// --------------------------------------------
export function submitDigitalRamNameApi(
  ramNamBookMemberID,
  totalCount,
  deviceTypeID,
  osInfo,
  deviceModelNo,
  osVersion,
  deviceID
) {
  return axios.post(Submit_Digital_Ram_Name, {
    ramNamBookMemberID,
    totalCount,
    deviceTypeID,
    osInfo,
    deviceModelNo,
    osVersion,
    deviceID,
  });
}
export function getDigitalRamNameCount(memberId) {
  return axios.get(`${Get_Digital_RamName_Count}?memberId=${memberId}`);
}
export function getMemberTotalSummary(memberId) {
  return axios.get(`${Get_Member_Total_Summary}?memberId=${memberId}`);
}
// ----------------------------------------------------------------
export function sendLoginRamNamOtpApi(
  countryID,
  mobileNumber,
  memberTypeID,
  countryCode,
) {
  return axios.post(Send_Login_Otp, {
    countryID,
    mobileNumber,
    memberTypeID,
    countryCode,
  });
}
export function verifyLoginRamNamOtpApi(mobileNumber, otp) {
  return axios.post(Verify_Login_Otp, { mobileNumber, otp });
}

// --------------------------------------------
export function getCountryActiveListApi() {
  return axios.get(Get_Countries);
}
export function resendRamNamBookOtpApi(
  countryID,
  mobileNumber,
  memberTypeID,
  countryCode,
) {
  return axios.post(ResendOtp_RamNamBook, {
    countryID,
    mobileNumber,
    memberTypeID,
    countryCode,
  });
}
